<template>
  <div class="ec-line017">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE016 }"> {{ $t('ec-line016.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item> {{ data.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <product-details
      :data="data"
      :items="items"
      :label-submit="$t('ec-line017.content.submitBtn')"
      :label-route="$t('ec-line017.content.routeBtn')"
      @submit="onSubmit"
    >
      <template #price="{ skuSelected }">
        <i18n path="common.includeTax">
          <template #num>
            <span class="text-xl lg:text-lg">{{ price(skuSelected) }}</span>
          </template>
        </i18n>
      </template>
    </product-details>
    <div class="w-full text-center mt-4 mb-1 lg:mt-8 lg:mb-4">
      <el-button class="cancel-btn" @click="toListProduct">{{ $t('common.action.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import ProductDetails from '@/components/ec-line017/ProductDetails.vue'
import { ProductService } from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  components: { ProductDetails },
  mixins: [BreadcrumbMixin],
  props: {
    id: { type: [Number, String], default: () => null },
  },
  data() {
    return {
      loading: false,
      data: {},
    }
  },
  computed: {
    subscription() {
      return this.$store.getters['subscription/getSubscription']
    },
    items() {
      return this.subscription?.subscription_order_item || []
    },
  },
  created() {
    if (this.subscription) {
      this.fetchItem()
    } else {
      this.$router.push({ name: 'EC_LINE014' })
    }
  },
  methods: {
    async fetchItem() {
      try {
        this.loading = true

        const { data } = await ProductService.getProductDetail(this.id)

        this.data = {
          ...data,
          product_images: data.product_images.sort((a, b) => a.sort_no - b.sort_no),
        }
      } catch (error) {
        this.$router.push({ name: '404' })
      } finally {
        this.loading = false
      }
    },
    onSubmit(sku) {
      const existed = this.items.some((i) => i.product_sku_id === sku.id)

      if (existed) {
        this.$router.push({ name: 'EC_LINE015', params: { id: this.subscription.id }, query: { isAddProduct: true } })
      } else {
        this.$store.commit('subscription/ADD_SKU_ITEM', {
          product_sku_id: sku.id,
          sku_item_parent_name_1: sku.sku_item_parent_name_1,
          sku_item_parent_name_2: sku.sku_item_parent_name_2,
          sku_set_item_name1: sku.sku_set_item_name1,
          sku_set_item_name2: sku.sku_set_item_name2,
          product_image: this.data.product_images[0].file_name,
          product_name: this.data.name,
          quantity: 1,
          price: Number(sku.price03_after_tax),
          sale_limit: this.data.product_sku[0].sale_limit,
          product_id: this.data.product_id,
        })

        this.$alert({
          message: this.$t('ec-line017.content.addCartSuccess'),
          type: 'success',
        })
      }
    },
    price(sku) {
      if (!sku) {
        return 0
      } else {
        return this.$n(sku.price03_after_tax, 'currency', 'ja-JP')
      }
    },
    toListProduct() {
      this.$router.push({ name: 'EC_LINE016' })
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line017.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line017.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line017.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line002.scss';
</style>
